import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { Link } from 'react-router-dom';
const CARD_HEIGHT_DEFAULT = 72;
const CARD_HEIGHT_WITH_BANNER = 194;
const CARD_HEIGHT_WITH_RECAP_ERROR = 117;
const BUFFER_HEIGHT = 41;
const determineMeetingCardHeight = ({
  hasBanner,
  hasRecapError,
  hasBeforeBuffer,
  hasAfterBuffer,
  isPhone,
  isPretending,
  hasToggleFeature
}) => {
  // Return auto height for mobile
  if (isPhone) {
    return 'auto';
  }
  let height = CARD_HEIGHT_DEFAULT;
  if (hasBanner && !isPretending) {
    height = CARD_HEIGHT_WITH_BANNER;
  }
  if (hasRecapError || isPretending) {
    height = CARD_HEIGHT_WITH_RECAP_ERROR;
  }

  // Uses default card height if toggle feature is enabled because recap indicator (no additional height)
  // is displayed instead of the the old banner
  if (hasToggleFeature) height = CARD_HEIGHT_DEFAULT;
  if (hasBeforeBuffer) {
    height += BUFFER_HEIGHT;
  }
  if (hasAfterBuffer) {
    height += BUFFER_HEIGHT;
  }
  return `${height}px`;
};
const meetingCardContainerIsPhoneCss = "m1s11wcq";
const meetingCardContainerIsSpotlightCss = "mysbs9v";
const meetingCardContainerIsActiveCss = "m1awi964";
const meetingCardContainerCss = "mi68i80";
export const MeetingCardContainer = forwardRef((props, ref) => {
  const {
    isSpotlight,
    hasBanner,
    hasRecapError,
    hasBeforeBuffer,
    hasAfterBuffer,
    isPretending,
    hasToggleFeature,
    active,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  const height = determineMeetingCardHeight({
    hasBanner,
    hasRecapError,
    hasBeforeBuffer,
    hasAfterBuffer,
    isPhone,
    isPretending,
    hasToggleFeature
  });
  return <Component ref={ref} {...restProps} style={{
    height
  }} className={classNames(meetingCardContainerCss, {
    [meetingCardContainerIsPhoneCss]: isPhone,
    [meetingCardContainerIsSpotlightCss]: isSpotlight,
    [meetingCardContainerIsActiveCss]: active
  }, props.className)} />;
});
const meetingLinkIsPhoneCss = "mxcb5op";
const meetingLinkIsLastCss = "m1p27fd8";
const meetingLinkHasEndBuffersCss = "mor59a";
const meetingLinkActiveCss = "m1sbjobf";
const meetingLinkHasStartBuffersCss = "mjqq9y0";
const meetingLinkIsFirstCss = "mxr6l9x";
const meetingLinkHasIndicatorBeforeCss = "m1rb4pun";
const meetingLinkHasIndicatorAfterCss = "m1qk590w";
const meetingLinkCss = "m1ybof00";
export const MeetingLink = forwardRef((props, ref) => {
  const {
    isLast,
    hasEndBuffers,
    active,
    hasStartBuffers,
    isFirst,
    hasIndicatorBefore,
    hasIndicatorAfter,
    ...restProps
  } = props;
  const isPhone = useDeviceType('isPhone');
  return <Link ref={ref} {...restProps} className={classNames(meetingLinkCss, {
    [meetingLinkIsPhoneCss]: isPhone,
    [meetingLinkIsLastCss]: isLast,
    [meetingLinkHasEndBuffersCss]: hasEndBuffers,
    [meetingLinkActiveCss]: active,
    [meetingLinkHasStartBuffersCss]: hasStartBuffers,
    [meetingLinkIsFirstCss]: isFirst,
    [meetingLinkHasIndicatorBeforeCss]: hasIndicatorBefore,
    [meetingLinkHasIndicatorAfterCss]: hasIndicatorAfter
  }, props.className)} />;
});
const timeRangeContainerIsPhoneCss = "t1x8dwgq";
const timeRangeContainerCss = "tp89sxi";
export const TimeRangeContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(timeRangeContainerCss, {
    [timeRangeContainerIsPhoneCss]: isPhone
  }, props.className)} />;
});
const phoneContainerCss = "pqqu1wq";
export const PhoneContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(phoneContainerCss, props.className)} />;
});

require("./styles.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");